export default "__VITE_ASSET__9jqm70hW__"